export function Sitemap() {
  return (
    <>
      <h1>Sitemap</h1>
      <p>This is the sitemap page, nothing to see here yet...</p>
    </>
  );
}
